// extracted by mini-css-extract-plugin
export default {"divider":"IbWmUUbm-8pw7--m-AYnow=="};